var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#8A8A8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4966 40.068C23.6646 40.068 22.95 39.7587 22.3526 39.14C21.7766 38.5427 21.4886 37.8173 21.4886 36.964C21.4886 36.1107 21.7766 35.3853 22.3526 34.788C22.95 34.1693 23.6646 33.86 24.4966 33.86C25.3286 33.86 26.0433 34.1693 26.6406 34.788C27.2593 35.3853 27.5686 36.1107 27.5686 36.964C27.5686 37.8173 27.27 38.5427 26.6726 39.14C26.0753 39.7587 25.35 40.068 24.4966 40.068ZM35.9629 40.068C35.1309 40.068 34.4162 39.7587 33.8189 39.14C33.2429 38.5427 32.9549 37.8173 32.9549 36.964C32.9549 36.1107 33.2429 35.3853 33.8189 34.788C34.4162 34.1693 35.1309 33.86 35.9629 33.86C36.7949 33.86 37.5095 34.1693 38.1069 34.788C38.7255 35.3853 39.0349 36.1107 39.0349 36.964C39.0349 37.8173 38.7362 38.5427 38.1389 39.14C37.5415 39.7587 36.8162 40.068 35.9629 40.068ZM47.4291 40.068C46.5971 40.068 45.8825 39.7587 45.2851 39.14C44.7091 38.5427 44.4211 37.8173 44.4211 36.964C44.4211 36.1107 44.7091 35.3853 45.2851 34.788C45.8825 34.1693 46.5971 33.86 47.4291 33.86C48.2611 33.86 48.9758 34.1693 49.5731 34.788C50.1918 35.3853 50.5011 36.1107 50.5011 36.964C50.5011 37.8173 50.2025 38.5427 49.6051 39.14C49.0078 39.7587 48.2825 40.068 47.4291 40.068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.785451b10e5c2b3acfc5649a789d42e7.svg";
export { ForwardRef as ReactComponent };